import _jsx from "@babel/runtime/helpers/jsx";
var _span;
import PropTypes from 'prop-types';
import React from 'react';
import clsx from 'clsx';
import Glyphicon from '../Glyphicon/index.js';
const renderLabelTextGlyph = (labelText, closeGlyph, openGlyph, uiContext, glyphClassName) => {
  const additionalClassnames = clsx({
    'display-md-none': uiContext === 'deepLinks',
    'text-accent': uiContext === 'deepLinks'
  }, glyphClassName);
  return /*#__PURE__*/_jsx("span", {
    role: "button",
    className: "display-flex flex-row justify-content-between"
  }, void 0, labelText, /*#__PURE__*/_jsx(Glyphicon, {
    className: clsx('toggle-close', additionalClassnames),
    glyph: closeGlyph
  }), /*#__PURE__*/_jsx(Glyphicon, {
    className: clsx('toggle-open', additionalClassnames),
    glyph: openGlyph
  }));
};
const renderLabelTextCaret = (labelText, showCaret) => /*#__PURE__*/_jsx("span", {
  role: "button"
}, void 0, labelText, showCaret && (_span || (_span = /*#__PURE__*/_jsx("span", {
  className: "caret margin-left-1"
}))));

/**
 *  Describe the component
 *
 */
function ToggledDropdown(_ref) {
  let {
    containerElement: Container = 'div',
    collapseElement: Component = 'div',
    componentRole,
    className,
    glyphClassName,
    collapseClassName,
    id,
    labelText,
    labelProps,
    showCaret = true,
    children,
    renderLabel,
    closeGlyph,
    openGlyph,
    labelForInput,
    uiContext = 'default',
    ...rest
  } = _ref;
  let label = '';
  if (closeGlyph && openGlyph) {
    label = renderLabelTextGlyph(labelText, closeGlyph, openGlyph, uiContext, glyphClassName);
  } else {
    label = renderLabelTextCaret(labelText, showCaret);
  }
  const isDeepLinks = uiContext === 'deepLinks';
  const containerClassNames = clsx('toggled-dropdown', className, {
    'deeplinks-dropdown': isDeepLinks
  });
  const menuClassnames = clsx('toggled-dropdown-menu', collapseClassName, {
    'display-md-block': isDeepLinks
  });
  return /*#__PURE__*/React.createElement(Container, Object.assign({
    className: containerClassNames
  }, rest), /*#__PURE__*/React.createElement("input", Object.assign({
    type: "checkbox",
    className: "toggled-dropdown-input",
    id: id
  }, labelForInput ? {
    'aria-label': labelForInput
  } : {})), renderLabel ? renderLabel(label, id) : /*#__PURE__*/React.createElement("label", Object.assign({
    htmlFor: id,
    className: "toggled-dropdown-label text-bold display-block display-sm-inline-block"
  }, labelProps), label), /*#__PURE__*/_jsx(Component, {
    className: menuClassnames,
    "aria-labelledby": id,
    "data-cmp": "toggle-dropdown-menu",
    role: componentRole
  }, void 0, children));
}
export default ToggledDropdown;